// extracted by mini-css-extract-plugin
module.exports = {"rating":"_3F9iIt","shine-lines":"_1tdZg4"};